const { PA_SUBJECT_VALUES, PA_GRADES_MAP, PA_SUBJECT_NAMES } = require('./pear')

const PDL_GRADES = [
  {
    id: '1',
    code: 'PK',
    description: 'Pre-K',
  },
  {
    id: '2',
    code: 'K',
    description: 'Kindergarten',
  },
  {
    id: '3',
    code: '1',
    description: '1st Grade',
  },
  {
    id: '4',
    code: '2',
    description: '2nd Grade',
  },
  {
    id: '5',
    code: '3',
    description: '3rd Grade',
  },
  {
    id: '6',
    code: '4',
    description: '4th Grade',
  },
  {
    id: '7',
    code: '5',
    description: '5th Grade',
  },
  {
    id: '8',
    code: '6',
    description: '6th Grade',
  },
  {
    id: '9',
    code: '7',
    description: '7th Grade',
  },
  {
    id: '10',
    code: '8',
    description: '8th Grade',
  },
  {
    id: '11',
    code: '9',
    description: '9th Grade',
  },
  {
    id: '12',
    code: '10',
    description: '10th Grade',
  },
  {
    id: '13',
    code: '11',
    description: '11th Grade',
  },
  {
    id: '14',
    code: '12',
    description: '12th Grade',
  },
  {
    id: '15',
    code: '13',
    description: '13th Grade',
  },
]

const PDL_SUBJECTS_MAP = {
  CIV: {
    id: '1',
    code: 'CIV',
    description: 'Civic/Social Responsibility',
  },
  COMM: {
    id: '2',
    code: 'COMM',
    description: 'Communication',
  },
  DANC: {
    id: '3',
    code: 'DANC',
    description: 'Arts: Dance',
  },
  DISC: {
    id: '4',
    code: 'DISC',
    description: 'Disciplinary Literacy',
  },
  ECOL: {
    id: '5',
    code: 'ECOL',
    description: 'Ecology',
  },
  ECON: {
    id: '6',
    code: 'ECON',
    description: 'Economics',

    deleted_at: null,
  },
  ENVI: {
    id: '7',
    code: 'ENVI',
    description: 'Environmental Literacy',
  },
  ESL: {
    id: '8',
    code: 'ESL',
    description: 'English as Second Language',
  },
  FORN: {
    id: '9',
    code: 'FORN',
    description: 'Foreign Language',
  },
  GEO: {
    id: '10',
    code: 'GEO',
    description: 'Geography',
  },
  GOV: {
    id: '11',
    code: 'GOV',
    description: 'Government',
  },
  HEAL: {
    id: '12',
    code: 'HEAL',
    description: 'Health Education',
  },
  HIST: {
    id: '13',
    code: 'HIST',
    description: 'History',
  },
  LANG: {
    id: '14',
    code: 'LANG',
    description: 'Language Arts',
  },
  MATH: {
    id: '15',
    code: 'MATH',
    description: 'Mathematics',
  },
  MEDA: {
    id: '16',
    code: 'MEDA',
    description: 'Arts: Media Arts',
  },
  PFL: {
    id: '17',
    code: 'PFL',
    description: 'Personal Financial Literacy',
  },
  PHYS: {
    id: '18',
    code: 'PHYS',
    description: 'Physical Education',
  },
  PROB: {
    id: '19',
    code: 'PROB',
    description: 'Reasoning and Problem Solving',
  },
  READ: {
    id: '20',
    code: 'READ',
    description: 'Reading',
  },
  SCI: {
    id: '21',
    code: 'SCI',
    description: 'Science',
  },
  SCIT: {
    id: '22',
    code: 'SCIT',
    description: 'Science and Technology',
  },
  SOC: {
    id: '23',
    code: 'SOC',
    description: 'Social Studies',
  },
  STEE: {
    id: '24',
    code: 'STEE',
    description: 'Science, Tech, Engineering, Environment',
  },
  THTR: {
    id: '25',
    code: 'THTR',
    description: 'Arts: Theatre',
  },
  VIS: {
    id: '26',
    code: 'VIS',
    description: 'Arts: Visual Arts',
  },
  VOC: {
    id: '27',
    code: 'VOC',
    description: 'Vocational Education',
  },
  WRIT: {
    id: '28',
    code: 'WRIT',
    description: 'Writing',
  },
  CS: {
    id: '29',
    code: 'CS',
    description: 'Computer Science',
  },
  OTHER: {
    id: '30',
    code: 'OTHER',
    description: 'Other Subjects',
  },
}

const PDL_SUBJECTS = Object.values(PDL_SUBJECTS_MAP)
const PDL_SUBJECT_NAMES = PDL_SUBJECTS.map(({ description }) => description)

const PDL_SUBJECT_MAP = {
  [PA_SUBJECT_VALUES.ELA]: {
    code: PDL_SUBJECTS_MAP.LANG.code,
    id: PDL_SUBJECTS_MAP.LANG.id,
  },
  [PA_SUBJECT_VALUES.MATHEMATICS]: {
    code: PDL_SUBJECTS_MAP.MATH.code,
    id: PDL_SUBJECTS_MAP.MATH.id,
  },
  [PA_SUBJECT_VALUES.SCIENCE]: {
    code: PDL_SUBJECTS_MAP.SCI.code,
    id: PDL_SUBJECTS_MAP.SCI.id,
  },
  [PA_SUBJECT_VALUES.SOCIAL_STUDIES]: {
    code: PDL_SUBJECTS_MAP.SOC.code,
    id: PDL_SUBJECTS_MAP.SOC.id,
  },
  [PA_SUBJECT_VALUES.COMPUTER_SCIENCE]: {
    code: PDL_SUBJECTS_MAP.CS.code,
    id: PDL_SUBJECTS_MAP.CS.id,
  },
  [PA_SUBJECT_VALUES.OTHER]: {
    code: PDL_SUBJECTS_MAP.OTHER.code,
    id: PDL_SUBJECTS_MAP.OTHER.id,
  },
}

const pearToAISubjectMap = (pearSubjectCode) => {
  switch (pearSubjectCode) {
    case PDL_SUBJECTS_MAP.SCI.description:
    case PDL_SUBJECTS_MAP.ECOL.description:
    case PDL_SUBJECTS_MAP.SCIT.description:
    case PDL_SUBJECTS_MAP.STEE.description:
      return PA_SUBJECT_VALUES.SCIENCE
    case PDL_SUBJECTS_MAP.MATH.description:
      return PA_SUBJECT_VALUES.MATHEMATICS
    case PDL_SUBJECTS_MAP.ESL.description:
    case PDL_SUBJECTS_MAP.LANG.description:
    case PDL_SUBJECTS_MAP.READ.description:
    case PDL_SUBJECTS_MAP.WRIT.description:
      return PA_SUBJECT_VALUES.ELA
    case PDL_SUBJECTS_MAP.CIV.description:
    case PDL_SUBJECTS_MAP.ECON.description:
    case PDL_SUBJECTS_MAP.GEO.description:
    case PDL_SUBJECTS_MAP.GOV.description:
    case PDL_SUBJECTS_MAP.HIST.description:
    case PDL_SUBJECTS_MAP.SOC.description:
      return PA_SUBJECT_VALUES.SOCIAL_STUDIES
    case PDL_SUBJECTS_MAP.COMM.description:
    case PDL_SUBJECTS_MAP.MEDA.description:
    case PDL_SUBJECTS_MAP.HEAL.description:
    case PDL_SUBJECTS_MAP.ENVI.description:
    case PDL_SUBJECTS_MAP.DANC.description:
    case PDL_SUBJECTS_MAP.DISC.description:
    case PDL_SUBJECTS_MAP.FORN.description:
    case PDL_SUBJECTS_MAP.PFL.description:
    case PDL_SUBJECTS_MAP.PHYS.description:
    case PDL_SUBJECTS_MAP.PROB.description:
    case PDL_SUBJECTS_MAP.VOC.description:
    case PDL_SUBJECTS_MAP.THTR.description:
    case PDL_SUBJECTS_MAP.VIS.description:
      return PA_SUBJECT_VALUES.OTHER
    default:
      return PA_SUBJECT_VALUES.OTHER
  }
}

const getPDLSubjectMappedToPASubject = (pearSubjectName = '') => {
  if (!pearSubjectName) {
    return ''
  }

  return PDL_SUBJECT_MAP[pearSubjectName]?.code || PDL_SUBJECTS_MAP.OTHER.code
}

const paToPdlSubjectIdMap = (pearSubjectName) => {
  if (!pearSubjectName) {
    return PDL_SUBJECTS_MAP.OTHER.id
  }

  return PDL_SUBJECT_MAP[pearSubjectName]?.id || PDL_SUBJECTS_MAP.OTHER.id
}

const pearToAIGradeMap = (pearGradeLevelCode) => {
  switch (pearGradeLevelCode) {
    case 'PK':
      return PA_GRADES_MAP.PRE_KINDERGARTEN.code
    case 'K':
      return PA_GRADES_MAP.KINDERGARTEN.code
    case '1':
      return PA_GRADES_MAP.GRADE_1.code
    case '2':
      return PA_GRADES_MAP.GRADE_2.code
    case '3':
      return PA_GRADES_MAP.GRADE_3.code
    case '4':
      return PA_GRADES_MAP.GRADE_4.code
    case '5':
      return PA_GRADES_MAP.GRADE_5.code
    case '6':
      return PA_GRADES_MAP.GRADE_6.code
    case '7':
      return PA_GRADES_MAP.GRADE_7.code
    case '8':
      return PA_GRADES_MAP.GRADE_8.code
    case '9':
      return PA_GRADES_MAP.GRADE_9.code
    case '10':
      return PA_GRADES_MAP.GRADE_10.code
    case '11':
      return PA_GRADES_MAP.GRADE_11.code
    case '12':
      return PA_GRADES_MAP.GRADE_12.code
    case '13':
      return PA_GRADES_MAP.GRADE_13.code
    default:
      return PA_GRADES_MAP.OTHER.code
  }
}

const pdlToPearGradeMap = (grade) => {
  const pdlToPaGrade = {
    1: 'TK',
    2: 'K',
    3: '1',
    4: '2',
    5: '3',
    6: '4',
    7: '5',
    8: '6',
    9: '7',
    10: '8',
    11: '9',
    12: '10',
    13: '11',
    14: '12',
    15: '13',
  }
  return pdlToPaGrade[grade] || ''
}

const pearToPdlGradeMap = (grade) => {
  const paToPdlGrade = {
    TK: '1',
    K: '2',
    1: '3',
    2: '4',
    3: '5',
    4: '6',
    5: '7',
    6: '8',
    7: '9',
    8: '10',
    9: '11',
    10: '12',
    11: '13',
    12: '14',
    13: '15',
  }
  return paToPdlGrade[grade] || ''
}

const pearToPdlGradeCodeMap = (paGradeCode = '') => {
  // need to return null because PDL doesn't have 'Other' grade option
  if (!paGradeCode) {
    return null
  }
  switch (paGradeCode) {
    case PA_GRADES_MAP.PRE_KINDERGARTEN.code:
      return 'PK'
    case PA_GRADES_MAP.KINDERGARTEN.code:
      return 'K'
    case PA_GRADES_MAP.GRADE_1.code:
      return '1'
    case PA_GRADES_MAP.GRADE_2.code:
      return '2'
    case PA_GRADES_MAP.GRADE_3.code:
      return '3'
    case PA_GRADES_MAP.GRADE_4.code:
      return '4'
    case PA_GRADES_MAP.GRADE_5.code:
      return '5'
    case PA_GRADES_MAP.GRADE_6.code:
      return '6'
    case PA_GRADES_MAP.GRADE_7.code:
      return '7'
    case PA_GRADES_MAP.GRADE_8.code:
      return '8'
    case PA_GRADES_MAP.GRADE_9.code:
      return '9'
    case PA_GRADES_MAP.GRADE_10.code:
      return '10'
    case PA_GRADES_MAP.GRADE_11.code:
      return '11'
    case PA_GRADES_MAP.GRADE_12.code:
      return '12'
    case PA_GRADES_MAP.GRADE_13.code:
      return '13'
    case PA_GRADES_MAP.OTHER.code:
    default:
      return null
  }
}

const ALL_SUBJECT_NAMES = PA_SUBJECT_NAMES

module.exports = {
  PDL_GRADES,
  PDL_SUBJECTS,
  PDL_SUBJECTS_MAP,
  PDL_SUBJECT_NAMES,
  pearToAISubjectMap,
  paToPdlSubjectIdMap,
  pearToAIGradeMap,
  getPDLSubjectMappedToPASubject,
  pdlToPearGradeMap,
  pearToPdlGradeMap,
  pearToPdlGradeCodeMap,
  ALL_SUBJECT_NAMES,
}
